import React from "react";
import { AnnotationMenuIconType, AnnotationMenuPropType } from "../AnnotationMenu";
import { AnnotationLabelIcons } from "../helpers/AnnotationLabelIcons";

const AnnotationMenuLabels = (props: AnnotationMenuPropType) => {
  const display = () => {
    return AnnotationLabelIcons.map((icon: AnnotationMenuIconType, index: number) => {
      return (
        <div
          id={icon.name}
          className={`annotation-icon`}
          key={index}
          onClick={(e: React.MouseEvent<HTMLDivElement>) => props.addNewAnnotation(e.currentTarget.id, "addLabel")}
        >
          {icon.icon}
        </div>
      );
    });
  };

  return <React.Fragment>{display()}</React.Fragment>;
};

export default AnnotationMenuLabels;
